// package: tradecopier
// file: trade-copier.proto

var trade_copier_pb = require("./trade-copier_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var TradeCopier = (function () {
  function TradeCopier() {}
  TradeCopier.serviceName = "tradecopier.TradeCopier";
  return TradeCopier;
}());

TradeCopier.AddConfig = {
  methodName: "AddConfig",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AddConfigReq,
  responseType: trade_copier_pb.AddConfigReply
};

TradeCopier.UpdateConfig = {
  methodName: "UpdateConfig",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.UpdateConfigReq,
  responseType: trade_copier_pb.UpdateConfigReply
};

TradeCopier.DeleteConfig = {
  methodName: "DeleteConfig",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.DeleteConfigReq,
  responseType: trade_copier_pb.DeleteConfigReply
};

TradeCopier.GetUserConfigs = {
  methodName: "GetUserConfigs",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.GetUserConfigsReq,
  responseType: trade_copier_pb.GetUserConfigsReply
};

TradeCopier.CopyExistingTrade = {
  methodName: "CopyExistingTrade",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.CopyExistingTradeReq,
  responseType: trade_copier_pb.CopyExistingTradeReply
};

TradeCopier.UpdateSymbolSettings = {
  methodName: "UpdateSymbolSettings",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.UpdateSymbolSettingsReq,
  responseType: trade_copier_pb.UpdateSymbolSettingsReply
};

TradeCopier.DeleteSymbolSettings = {
  methodName: "DeleteSymbolSettings",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.DeleteSymbolSettingsReq,
  responseType: trade_copier_pb.DeleteSymbolSettingsReply
};

TradeCopier.ListSymbolSettings = {
  methodName: "ListSymbolSettings",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.ListSymbolSettingsReq,
  responseType: trade_copier_pb.ListSymbolSettingsReply
};

TradeCopier.PauseAccountSymbol = {
  methodName: "PauseAccountSymbol",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.PauseAccountSymbolReq,
  responseType: trade_copier_pb.PauseAccountSymbolReply
};

TradeCopier.AssociatedMasterSymbol = {
  methodName: "AssociatedMasterSymbol",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AssociatedMasterSymbolReq,
  responseType: trade_copier_pb.AssociatedMasterSymbolReply
};

TradeCopier.PauseAccount = {
  methodName: "PauseAccount",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.PauseAccountReq,
  responseType: trade_copier_pb.PauseAccountReply
};

TradeCopier.AddSlaves = {
  methodName: "AddSlaves",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AddSlavesReq,
  responseType: trade_copier_pb.AddSlaveReply
};

TradeCopier.DeleteSlaves = {
  methodName: "DeleteSlaves",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.DeleteSalvesReq,
  responseType: trade_copier_pb.DeleteSlavesReply
};

TradeCopier.UpdateSlave = {
  methodName: "UpdateSlave",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.UpdateSlaveReq,
  responseType: trade_copier_pb.UpdateSlaveReply
};

TradeCopier.UpdateSlaveMany = {
  methodName: "UpdateSlaveMany",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.UpdateSlaveManyReq,
  responseType: trade_copier_pb.UpdateSlaveManyReply
};

TradeCopier.ListSymbolMappings = {
  methodName: "ListSymbolMappings",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.ListSymbolMappingsReq,
  responseType: trade_copier_pb.ListSymbolMappingsReply
};

TradeCopier.AddSymbolMapping = {
  methodName: "AddSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AddSymbolMappingReq,
  responseType: trade_copier_pb.AddSymbolMappingReply
};

TradeCopier.DeleteSymbolMapping = {
  methodName: "DeleteSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.DeleteSymbolMappingReq,
  responseType: trade_copier_pb.DeleteSymbolMappingReply
};

TradeCopier.EditSymbolMapping = {
  methodName: "EditSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.EditSymbolMappingReq,
  responseType: trade_copier_pb.EditSymbolMappingReply
};

TradeCopier.AddCopierTemplate = {
  methodName: "AddCopierTemplate",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AddCopierTemplateReq,
  responseType: trade_copier_pb.AddCopierTemplateReply
};

TradeCopier.UpdateCopierTemplate = {
  methodName: "UpdateCopierTemplate",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.UpdateCopierTemplateReq,
  responseType: trade_copier_pb.UpdateCopierTemplateReply
};

TradeCopier.DeleteCopierTemplate = {
  methodName: "DeleteCopierTemplate",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.DeleteCopierTemplateReq,
  responseType: trade_copier_pb.DeleteCopierTemplateReply
};

TradeCopier.ListCopierTemplate = {
  methodName: "ListCopierTemplate",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.ListCopierTemplateReq,
  responseType: trade_copier_pb.ListCopierTemplateReply
};

TradeCopier.AdminGetUserConfigs = {
  methodName: "AdminGetUserConfigs",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminGetUserConfigsReq,
  responseType: trade_copier_pb.AdminGetUserConfigsReply
};

TradeCopier.AdminUpdateConfig = {
  methodName: "AdminUpdateConfig",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminUpdateConfigReq,
  responseType: trade_copier_pb.AdminUpdateConfigReply
};

TradeCopier.AdminUpdateSlave = {
  methodName: "AdminUpdateSlave",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminUpdateSlaveReq,
  responseType: trade_copier_pb.AdminUpdateSlaveReply
};

TradeCopier.AdminListSymbolMappings = {
  methodName: "AdminListSymbolMappings",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminListSymbolMappingsReq,
  responseType: trade_copier_pb.AdminListSymbolMappingsReply
};

TradeCopier.AdminAddSymbolMapping = {
  methodName: "AdminAddSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminAddSymbolMappingReq,
  responseType: trade_copier_pb.AdminAddSymbolMappingReply
};

TradeCopier.AdminDeleteSymbolMapping = {
  methodName: "AdminDeleteSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminDeleteSymbolMappingReq,
  responseType: trade_copier_pb.AdminDeleteSymbolMappingReply
};

TradeCopier.AdminEditSymbolMapping = {
  methodName: "AdminEditSymbolMapping",
  service: TradeCopier,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.AdminEditSymbolMappingReq,
  responseType: trade_copier_pb.AdminEditSymbolMappingReply
};

exports.TradeCopier = TradeCopier;

function TradeCopierClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

TradeCopierClient.prototype.addConfig = function addConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AddConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.updateConfig = function updateConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.UpdateConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.deleteConfig = function deleteConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.DeleteConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.getUserConfigs = function getUserConfigs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.GetUserConfigs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.copyExistingTrade = function copyExistingTrade(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.CopyExistingTrade, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.updateSymbolSettings = function updateSymbolSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.UpdateSymbolSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.deleteSymbolSettings = function deleteSymbolSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.DeleteSymbolSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.listSymbolSettings = function listSymbolSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.ListSymbolSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.pauseAccountSymbol = function pauseAccountSymbol(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.PauseAccountSymbol, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.associatedMasterSymbol = function associatedMasterSymbol(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AssociatedMasterSymbol, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.pauseAccount = function pauseAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.PauseAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.addSlaves = function addSlaves(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AddSlaves, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.deleteSlaves = function deleteSlaves(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.DeleteSlaves, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.updateSlave = function updateSlave(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.UpdateSlave, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.updateSlaveMany = function updateSlaveMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.UpdateSlaveMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.listSymbolMappings = function listSymbolMappings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.ListSymbolMappings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.addSymbolMapping = function addSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AddSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.deleteSymbolMapping = function deleteSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.DeleteSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.editSymbolMapping = function editSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.EditSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.addCopierTemplate = function addCopierTemplate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AddCopierTemplate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.updateCopierTemplate = function updateCopierTemplate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.UpdateCopierTemplate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.deleteCopierTemplate = function deleteCopierTemplate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.DeleteCopierTemplate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.listCopierTemplate = function listCopierTemplate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.ListCopierTemplate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminGetUserConfigs = function adminGetUserConfigs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminGetUserConfigs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminUpdateConfig = function adminUpdateConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminUpdateConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminUpdateSlave = function adminUpdateSlave(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminUpdateSlave, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminListSymbolMappings = function adminListSymbolMappings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminListSymbolMappings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminAddSymbolMapping = function adminAddSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminAddSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminDeleteSymbolMapping = function adminDeleteSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminDeleteSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

TradeCopierClient.prototype.adminEditSymbolMapping = function adminEditSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(TradeCopier.AdminEditSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.TradeCopierClient = TradeCopierClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "tradecopier.Internal";
  return Internal;
}());

Internal.IntDeleteMasterSlaves = {
  methodName: "IntDeleteMasterSlaves",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntDeleteMasterSlavesReq,
  responseType: trade_copier_pb.IntDeleteMasterSlavesReply
};

Internal.IntGetUserMasterAccounts = {
  methodName: "IntGetUserMasterAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntGetUserMasterAccountsReq,
  responseType: trade_copier_pb.IntGetUserMasterAccountsReply
};

Internal.IntGetLogs = {
  methodName: "IntGetLogs",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntGetLogsReq,
  responseType: trade_copier_pb.IntGetLogsReply
};

Internal.IntGetUsersConfigsCount = {
  methodName: "IntGetUsersConfigsCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntGetUsersConfigsCountReq,
  responseType: trade_copier_pb.IntGetUsersConfigsCountReply
};

Internal.IntGetMasterAndSlaveCount = {
  methodName: "IntGetMasterAndSlaveCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntGetMasterAndSlaveCountReq,
  responseType: trade_copier_pb.IntGetMasterAndSlaveCountReply
};

Internal.IntSlaveAccountIDs = {
  methodName: "IntSlaveAccountIDs",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntSlaveAccountIDsReq,
  responseType: trade_copier_pb.IntSlaveAccountIDsReply
};

Internal.IntCheckMasterConfig = {
  methodName: "IntCheckMasterConfig",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntCheckMasterConfigReq,
  responseType: trade_copier_pb.IntCheckMasterConfigReply
};

Internal.IntListSymbolMapping = {
  methodName: "IntListSymbolMapping",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntListSymbolMappingReq,
  responseType: trade_copier_pb.IntListSymbolMappingReply
};

Internal.IntMapSymbolInBulk = {
  methodName: "IntMapSymbolInBulk",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: trade_copier_pb.IntMapSymbolInBulkReq,
  responseType: trade_copier_pb.IntMapSymbolInBulkReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intDeleteMasterSlaves = function intDeleteMasterSlaves(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteMasterSlaves, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUserMasterAccounts = function intGetUserMasterAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUserMasterAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetLogs = function intGetLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUsersConfigsCount = function intGetUsersConfigsCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUsersConfigsCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetMasterAndSlaveCount = function intGetMasterAndSlaveCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetMasterAndSlaveCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSlaveAccountIDs = function intSlaveAccountIDs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSlaveAccountIDs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intCheckMasterConfig = function intCheckMasterConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntCheckMasterConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intListSymbolMapping = function intListSymbolMapping(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntListSymbolMapping, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intMapSymbolInBulk = function intMapSymbolInBulk(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntMapSymbolInBulk, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

